import loadable from '@loadable/component';

const UserPage = loadable(() => import('./UserPage'));

export { UserPage };
